import { createContext, useContext, useMemo } from "react";
import { useSetState } from "react-use";

const initialState = {
  run: false,
  stepIndex: 0,
  steps: [],
  actions: {}, 
};

export const TourContext = createContext({
  state: initialState,
  setState: () => {},
});

export function TourProvider({ children }) {
  const [state, setState] = useSetState(initialState);

  const registerTourAction = (name, fn) => {
    setState((prev) => ({
      actions: { ...prev.actions, [name]: fn },
    }));
  };

  const value = useMemo(
    () => ({ state, setState, registerTourAction }),
    [state, setState]
  );

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}

export function useTour() {
  const context = useContext(TourContext);
  if (!context) throw new Error("useTour must be used within TourProvider");
  return context;
}
